import React from 'react';
import PartnerPage from 'pages/PartnerPage/PartnerPage';

const Partner = () => {
    return (
        <PartnerPage/>
    );
};

export default Partner;